import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import { GroupedShippingItemsResponse, Committee, ShippingItemDetail, CropFamic, ProducerModel, FertilizerModel, ChemicalModel, CollectionAndShippingGroup, LoginUser } from "@/types/Component";
import SelectCropFamicModal from '@/assets/common/Modal/SelectCropFamicModal/SelectCropFamicModal.vue';
import ChemicalMemoModal from '@/assets/common/Modal/ChemicalMemoModal/ChemicalMemoModal.vue';
import FertilizerApprovalModal from '@/assets/common/Modal/FertilizerApprovalModal/FertilizerApprovalModal.vue';
import ProducerSelectModal from '@/assets/common/Modal/ItemSelectModal/ProducerSelectModal/ProducerSelectModal.vue'
import FertilizerSelectModal from '@/assets/common/Modal/ItemSelectModal/FertilizerSelectModal/FertilizerSelectModal.vue';
import ChemicalSelectModal from '@/components/Warehouses/ChemicalSelectModal/ChemicalSelectModal.vue';

type FormCommittee = {
    id: string;
    name: string;
    isHidden: boolean;
}

type CommitteesResponse = {
  committees: FormCommittee[];
};

type Fertilizer = {
    id: string;
    name: string;
    isHidden: boolean;
}

@Component({
    components: {
        ChemicalMemoModal,
        ProducerSelectModal,
        FertilizerSelectModal,
        ChemicalSelectModal,
        FertilizerApprovalModal,
        SelectCropFamicModal
    },
})
export default class ShippingItems extends Vue {

    selectedTab: 'basic' | 'producers' | 'fertilizers' | 'chemicals' = 'basic'
    showChemicalMemoModal = false
    showProducerSelectModal = false
    showFertilizerSelectModal = false
    showChemicalSelectModal = false
    showFertilizerApprovalModal = false
    showCropsFamicModal = false

    isReadOnly = false;

    mode: 'new' | 'edit' | 'view' = 'edit';
    selectedChemical: ChemicalModel | null = null;

    get title(): string {
        return this.mode === 'new' ? '新規出荷品目' : '出荷品目情報';
    }

    get isShippingIemsModalOpen():boolean{
        return (
        this.showProducerSelectModal ||
        this.showFertilizerSelectModal ||
        this.showChemicalSelectModal ||
        this.showChemicalMemoModal ||
        this.showFertilizerApprovalModal ||
        this.showCropsFamicModal
        )
    }

    selectTab(tab: 'basic' | 'producers' | 'fertilizers' | 'chemicals'): void {
        this.selectedTab = tab
    }

    openSideBar = () => {
        if (document.body.classList.contains('sideopen')) {
            document.body.classList.remove('sideopen')
        } else {
            document.body.classList.add('sideopen')
        }
    }

    private isLoading = false;
    private withHidden = false;
    private onlyBelongsTo = true;
    private baseUrl = '/shipping_items';
    private committeesOrg: Committee[] = [];
    private collectionAndShippingGroups: CollectionAndShippingGroup[] = [];
    private selectedCollectionAndShippingGroup: CollectionAndShippingGroup | null = null;
    private committees: Committee[] = [];
    private formCommittees: FormCommittee[] = []
    private shippingItemId: string | null = null;
    private sourceShippingItemId: string | null = null;
    private selectedTenantId: string | null = null;
    private searchText = '';
    private form: ShippingItemDetail = this.getEmptyForm();
    private originalForm : ShippingItemDetail = this.getEmptyForm();
    private cropFamic: CropFamic | null = null;
    private selectedFertilizer: FertilizerModel | null = null;
    private previousComId: string | null = null;
    private alertMessage = 'リクエストに失敗しました。\n'
    private deleteProducers: ProducerModel[] = []
    private deleteFertilizers: FertilizerModel[] = []
    private deleteChemicals: ChemicalModel[] = []

    getEmptyForm(): ShippingItemDetail {
        return {
            name: '',
            comId: '',
            comName: '',
            cropItemId: '',
            cropItemName: '',
            cropItemHiragana: '',
            cvMethod: null,
            cropType: '',
            cvStartDate: null,
            cvEndDate: null,
            sowingStartDate: null,
            sowingEndDate: null,
            plantingStartDate: null,
            plantingEndDate: null,
            shippingStartDate: null,
            shippingEndDate: null,
            scheduledShippingQuantity: null,
            averageYield: null,
            kcontTotal: null,
            kcontTotalAlert: null,
            chemicalUseCount: null,
            chemicalUseCountAlert: null,
            isHidden: false,
            isDeletable: true,
            updated : '',
            producers: [],
            fertilizers: [],
            chemicals: [],
            deletedProducers: [],
            deletedFertilizers: [],
            deletedChemicals: [],
        };
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get isPesticidePlan() : boolean {
        return this.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer() : boolean {
        return this.loginUser.pesticidePlanProducer;
    }

    created() {
        this.getList();
        this.shippingItemId = this.$route.params.id || null;
        if (this.shippingItemId) {
            this.getCommittees();
            this.mode = this.shippingItemId === 'create' ? 'new' : 'edit';
            this.shippingItemId === 'create' ? this.newForm() : this.getShippingItemDetail();
        }
    }

    setShippingItemId(id: string, flag:boolean) {
        if (this.$route.params.id === id) return;
        if (this.$store.getters.isInputChanged && !window.confirm('変更内容を破棄します。よろしいですか？')) return false;
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.$router.push({ name: 'ShippingItemDetail', params: { id } });
        this.shippingItemId = id;
        this.getEmptyForm();
        this.getShippingItemDetail();
        if(flag){
            this.openSideBar();
        }
    }

    handleBukai() {
        if (this.form.producers?.length === 0) {
            this.previousComId = this.form.comId;
            this.inputChanged();
            return;
        }

        if (!window.confirm("タブ「生産者」の内容がクリアされます。よろしいですか？")) {
            this.form.comId = this.previousComId;
            return;
        }

        this.form.producers = [];
        this.previousComId = this.form.comId;
        this.inputChanged();
    }

    async getShippingItemDetail() {
        this.mode = 'edit';
        this.getCommittees();
        this.isLoading = true;
        this.previousComId = null;
        this.sourceShippingItemId = null;
        try {
            const res = await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.shippingItemId}`);
            this.form = toCamel(res) as ShippingItemDetail;
            this.originalForm = toCamel(res) as ShippingItemDetail;
            this.previousComId = this.form.comId;
            this.cropFamic = {
                id: this.form.cropItemId,
                name: this.form.cropItemName,
                hiragana: this.form.cropItemHiragana
            };
            (this.form.chemicals ?? []).forEach(c => {
                c.isSavedApproved = !!c.approvedDate;
            });
            (this.form.fertilizers ?? []).forEach(f => {
                f.isSavedApproved = !!f.approvedDate;
            });
            this.form.deletedProducers = [];
            this.form.deletedFertilizers = [];
            this.form.deletedChemicals = [];
        } catch (error) {
            this.$toasted.error('出荷品目の取得に失敗しました');
        } finally {
            this.isLoading = false;
        }
    }

    @Watch('searchText')
    doSearch() {
        if (this.searchText) {
            const keyword = this.searchText;
            this.committees = this.committeesOrg.map(committee => {
                const committeeMatch = committee.committeeName.includes(keyword);
                const filteredItems = committee.shippingItems.filter(item =>
                    item.name.includes(keyword)
                );
                if (committeeMatch) {
                    return { ...committee };
                } else if (filteredItems.length > 0) {
                    return { ...committee, shippingItems: filteredItems };
                }
                return null;
            }).filter((committee): committee is Committee => committee !== null);
        } else {
            this.committees = this.committeesOrg;
        }
    }

    @Watch('isShippingIemsModalOpen')
    onAnyModalVisibilityChanged(val: boolean) {
        this.$root.$emit('header-inert', val);
    }

    async getList() {
        this.searchText = '';
        this.isLoading = true;
        try {
            const flag = !this.isPesticidePlan && this.pesticidePlanProducer ? this.onlyBelongsTo : false;
            const res = await this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${this.withHidden}&only_belongs_to=${flag}`);
            const camelCasedResponse = toCamel(res) as GroupedShippingItemsResponse;
            this.isReadOnly = camelCasedResponse.isReadOnly;
            this.collectionAndShippingGroups = camelCasedResponse.collectionAndShippingGroups;
            this.selectedCollectionAndShippingGroup = this.collectionAndShippingGroups.find(group => group.isSelected) || null;
            this.selectedTenantId = this.selectedCollectionAndShippingGroup?.tenantId || null;
            this.committeesOrg = camelCasedResponse.committees.map(c => ({ ...c, isOpen: true }));
            this.committees = this.committeesOrg.map(c => ({
                ...c,
                shippingItems: [...c.shippingItems]
            }));
        } catch (error) {
            this.$toasted.error('データの取得に失敗しました。');
        } finally {
            this.isLoading = false;
        }
    }

    async getCommittees() {
        this.isLoading = true;
        try {
            const res = await this.$apiClient.doRequest('get', '/committees?with_hidden=true');
            this.formCommittees = (toCamel(res) as CommitteesResponse).committees;
        } catch (error) {
            this.$toasted.error('データの取得に失敗しました。');
        } finally {
            this.isLoading = false;
        }
    }

    get filteredCommittees() {
        return this.formCommittees.filter(c => this.form.comId == c.id || !c.isHidden)
    }

    newForm(flag = false) {
        if (flag && this.$store.getters.isInputChanged) {
            if (!window.confirm('変更内容を破棄します。よろしいですか？')) return;
            this.$store.dispatch('doUpdateIsInputChanged', false);
        }
        this.selectedTab = 'basic';
        this.shippingItemId = "create";
        this.mode = 'new';
        this.form = this.getEmptyForm();
        this.cropFamic = null;
        this.getCommittees();
        this.$router.push({ name: 'ShippingItemDetail', params: { id: 'create' } });
        this.previousComId = null;
        if(flag){
            this.sourceShippingItemId = null;
            this.openSideBar();
        }
    }

    validate() {
        const errors: string[] = [];
        const regex = /^\d{1,7}(\.\d{1,2})?$/;
        this.form.name = this.form.name?.trim() || '';
        this.form.cropType = this.form.cropType?.trim() || '';

        if (!this.form.comId) {
            errors.push('部会を選択してください。');
        }

        if (!this.form.name) {
            errors.push('出荷品目名を入力してください。');
        } else if (this.form.name.length > 100) {
            errors.push(`出荷品目名は100文字以内で入力してください。（現在は${this.form.name.length}文字）`);
        }

        if (!this.form.cropItemId) {
            errors.push('品目を選択してください。');
        }

        if (this.form.cvMethod === null) {
            errors.push('栽培方法を選択してください。');
        }

        if (this.form.cropType && this.form.cropType.length > 40) {
            errors.push(`作型は40文字以内で入力してください。（現在は${this.form.cropType.length}文字）`);
        }

        const {
            cvStartDate, cvEndDate,
            sowingStartDate, sowingEndDate,
            plantingStartDate, plantingEndDate,
            shippingStartDate, shippingEndDate
        } = this.form;

        if ((cvStartDate && !cvEndDate) || (!cvStartDate && cvEndDate)) {
            errors.push('栽培予定の開始日と終了日は両方入力してください。');
        } else if (cvStartDate && cvEndDate && cvEndDate <= cvStartDate) {
            errors.push('栽培予定の終了日は開始日より後にしてください。');
        }

        function isInRange(date: Date, start: Date, end: Date) {
            return date >= start && date <= end;
        }

        if ((sowingStartDate && !sowingEndDate) || (!sowingStartDate && sowingEndDate)) {
            errors.push('播種予定の開始日と終了日は両方入力してください。');
        } else if (sowingStartDate && sowingEndDate) {
            if (sowingEndDate <= sowingStartDate) {
                errors.push('播種予定の終了日は開始日より後にしてください。');
            }
            if (cvStartDate && cvEndDate) {
                if (!isInRange(sowingStartDate, cvStartDate, cvEndDate) || !isInRange(sowingEndDate, cvStartDate, cvEndDate)) {
                    errors.push('播種予定日は栽培予定日の範囲内で指定してください。');
                }
            }
        }

        if ((plantingStartDate && !plantingEndDate) || (!plantingStartDate && plantingEndDate)) {
            errors.push('定植予定の開始日と終了日は両方入力してください。');
        } else if (plantingStartDate && plantingEndDate) {
            if (plantingEndDate <= plantingStartDate) {
                errors.push('定植予定の終了日は開始日より後にしてください。');
            }
            if (cvStartDate && cvEndDate) {
                if (!isInRange(plantingStartDate, cvStartDate, cvEndDate) || !isInRange(plantingEndDate, cvStartDate, cvEndDate)) {
                    errors.push('定植予定日は栽培予定日の範囲内で指定してください。');
                }
            }
        }

        if ((shippingStartDate && !shippingEndDate) || (!shippingStartDate && shippingEndDate)) {
            errors.push('出荷予定の開始日と終了日は両方入力してください。');
        } else if (shippingStartDate && shippingEndDate) {
            if (shippingEndDate <= shippingStartDate) {
                errors.push('出荷予定の終了日は開始日より後にしてください。');
            }
            if (cvStartDate && cvEndDate) {
                if (!isInRange(shippingStartDate, cvStartDate, cvEndDate) || !isInRange(shippingEndDate, cvStartDate, cvEndDate)) {
                    errors.push('出荷予定日は栽培予定日の範囲内で指定してください。');
                }
            }
        }

        const quantity = this.form.scheduledShippingQuantity?.toString() ?? null;
        if (quantity !== null && quantity !== undefined && quantity !== "") {
            if (!regex.test(quantity)) {
                errors.push('出荷予定量は整数部7桁、小数部2桁までの数値を入力してください。');
            }
        }

        const averageYield = this.form.averageYield?.toString() ?? null;
        if (averageYield !== null && averageYield !== undefined && averageYield !== "") {
            if (!regex.test(averageYield)) {
                errors.push('平均反収は整数部7桁、小数部2桁までの数値を入力してください。');
            }
        }

        (this.form.producers ?? []).forEach((p) => {
            const area = p.cvPlanArea?.toString() ?? null;
            if (p.registrationDivision !== 1 && area != null && area  !== "") {
                if (!regex.test(area)) {
                    errors.push(`栽培面積は整数部7桁、小数部2桁までの数値を入力してください。（生産者：${p.name}）`);
                }
            }
        });

        const kcontTotal = this.form.kcontTotal?.toString() ?? null;
        if (kcontTotal !== null && kcontTotal !== undefined && kcontTotal  !== "") {
            if (!regex.test(kcontTotal)) {
                errors.push('化学肥料（窒素成分）は整数部7桁、小数部2桁までの数値を入力してください。');
            }
        }

        const kcontTotalAlert = this.form.kcontTotalAlert?.toString() ?? null;
        if (kcontTotalAlert !== null && kcontTotalAlert !== undefined && kcontTotalAlert  !== "") {
            if (!regex.test(kcontTotalAlert)) {
                errors.push('化学肥料（窒素成分）アラートは整数部7桁、小数部2桁までの数値を入力してください。');
            }
            if (
                kcontTotal !== null &&
                kcontTotal !== undefined &&
                Number(kcontTotalAlert) >= Number(kcontTotal)
            ) {
                errors.push('化学肥料（窒素成分）アラートは化学肥料（窒素成分）より小さい値を入力してください。');
            }
        }

        const chemicalUseCount = this.form.chemicalUseCount?.toString() ?? null;
        if (chemicalUseCount !== null && chemicalUseCount !== undefined && chemicalUseCount  !== "") {
            const re = /^\d{1,4}$/;
            if (!re.test(chemicalUseCount)) {
                errors.push('農薬の使用回数は整数部4桁以内の数値を入力してください。');
            }
        }

        const chemicalUseCountAlert = this.form.chemicalUseCountAlert?.toString() ?? null;
        if (chemicalUseCountAlert !== null && chemicalUseCountAlert !== undefined && chemicalUseCountAlert  !== "") {
            const re = /^\d{1,4}$/;
            if (!re.test(chemicalUseCountAlert)) {
                errors.push('農薬の使用回数アラートは整数4桁以内の数値を入力してください。');
            }
            if (
                chemicalUseCount !== null &&
                chemicalUseCount !== undefined &&
                Number(chemicalUseCountAlert) >= Number(chemicalUseCount)
            ) {
                errors.push('農薬の使用回数アラートは農薬の使用回数より小さい値を入力してください。');
            }
        }

        (this.form.chemicals ?? []).forEach((c) => {
            if (c.memo && c.memo.trim().length > 200) {
                errors.push(`補足は200文字以内で入力してください。（現在は${c.memo.length}文字、 農薬名：${c.name}）`);
            }
        });

        if (errors.length > 0) {
            window.alert(errors.join('\n'));
            return false;
        }

        return true;
    }

    async saveForm(isCopying = false) {
        this.sourceShippingItemId = null;
        if (!this.validate()) return;
        const isCreating = this.shippingItemId === 'create';
        if (!isCreating && !window.confirm('内容を上書きして保存します。よろしいですか？')) return;
        const method = isCreating ? 'post' : 'put';
        const msg = isCreating ? '保存しました。' : '変更を保存しました。';
        const url = isCreating ? this.baseUrl : `${this.baseUrl}/${this.shippingItemId}`;
        this.isLoading = true;
        this.$root.$emit('header-inert', true);
        if (!isCreating) {
            if (this.originalForm?.producers) {
                const currentProducers = this.form.producers ?? [];
                this.form.deletedProducers = this.originalForm.producers.filter(
                    originalProducer => !currentProducers.some(p => p.id === originalProducer.id)
                );
                currentProducers.forEach(currentProducer => {
                    if (currentProducer.updated === null) {
                        const originalProducer = this.originalForm.producers?.find(o => o.id === currentProducer.id);
                        if (originalProducer) {
                            currentProducer.updated = originalProducer.updated;
                        }
                    }
                });
            }
    
            if (this.originalForm?.fertilizers) {
                const currentFertilizers = this.form.fertilizers ?? [];
                this.form.deletedFertilizers = this.originalForm.fertilizers.filter(
                    originalFertilizer => !currentFertilizers.some(f => f.id === originalFertilizer.id)
                );
                currentFertilizers.forEach(currentFertilizer => {
                    if (currentFertilizer.updated === null) {
                        const originalFertilizer = this.originalForm.fertilizers?.find(o => o.id === currentFertilizer.id);
                        if (originalFertilizer) {
                            currentFertilizer.updated = originalFertilizer.updated;
                        }
                    }
                });
            }
    
            if (this.originalForm?.chemicals) {
                const currentChemicals = this.form.chemicals ?? [];
                this.form.deletedChemicals = this.originalForm.chemicals.filter(
                    originalChemical => !currentChemicals.some(c => c.id === originalChemical.id)
                );
                currentChemicals.forEach(currentChemical => {
                    if (currentChemical.updated === null) {
                        const originalChemical = this.originalForm.chemicals?.find(o => o.id === currentChemical.id);
                        if (originalChemical) {
                            currentChemical.updated = originalChemical.updated;
                        }
                    }
                });
            }
        }
        try {
            const response = await this.$apiClient.doRequest(method, url, this.form);
            if (response.message) {
                window.alert(this.alertMessage + response.message);
                this.$toasted.error('変更に失敗しました。')
                return;
            }
            this.$toasted.success(msg);
            this.$store.dispatch('doUpdateIsInputChanged', false);
            this.getList();
            if (isCreating) {
                if (response.id && !isCopying) {
                    this.setShippingItemId(response.id, false);
                }
            } else {
                this.getShippingItemDetail();
            }
            if (isCopying) {
                this.sourceShippingItemId = response.id;
                this.duplicateForm();
            }
        } catch (error) {
            this.$root.$emit('header-inert', false);
            this.$toasted.error('保存に失敗しました。');
        } finally {
            this.$root.$emit('header-inert', false);
            this.isLoading = false;
        }
    }

    private async duplicateForm() {
        this.newForm();
        if (!this.sourceShippingItemId) return;
        this.isLoading = true;
        try {
            const res = await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.sourceShippingItemId}`);
            this.form = toCamel(res) as ShippingItemDetail;
            this.originalForm = toCamel(res) as ShippingItemDetail;
            this.form.name = `${this.form.name}のコピー`;
            this.form.isDeletable = true;
            this.previousComId = this.form.comId;
            this.cropFamic = {
                id: this.form.cropItemId,
                name: this.form.cropItemName,
                hiragana: this.form.cropItemHiragana
            };
            this.form.producers = this.form.producers?.map(p => ({
                ...p,
                registrationDivision: 0,
                isDeletable: true
            })) || [];
            const resetOrRemove = (items: any[]) =>
                items
                ?.map(item => {
                    if (item.registrationDivision === 1) {
                    return item.approvedDate
                        ? { ...item, registrationDivision: 0, approvedDate: null, producerName: null }
                        : null;
                    }
                    return { ...item, approvedDate: null };
                })
                .filter(Boolean) || [];
            this.form.chemicals = (resetOrRemove(this.form.chemicals ?? []) || []).map(c => ({...c,isDeletable: true}));
            this.form.fertilizers = (resetOrRemove(this.form.fertilizers ?? []) || []).map(f => ({...f,isDeletable: true}));
        } catch (error) {
            this.$toasted.error('出荷品目の取得に失敗しました');
        } finally {
            this.isLoading = false;
        }
    }

    deleteForm() {
        if (!this.shippingItemId) return;
        if (!window.confirm(`出荷品目「${this.form.name}」を削除します。よろしいですか？`)) return;
        this.isLoading = true;
        this.$root.$emit('header-inert', true);
        this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.shippingItemId}`,this.form)
            .then((response: any) => {
                if (response.message != null) {
                    window.alert(this.alertMessage + response.message);
                    this.$toasted.error('変更に失敗しました。')
                    this.isLoading = false;
                    this.$root.$emit('header-inert', false);
                    return;
                }
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.form = this.getEmptyForm();
                this.shippingItemId = null;
                this.$toasted.success('削除しました。');
                this.cropFamic = null;
                this.getList();
                this.$router.push({ name: 'ShippingItems' });
            })
            .catch(() => {
                this.$toasted.error('削除に失敗しました。');
            })
            .finally(() => {
                this.$root.$emit('header-inert', false);
                this.isLoading = false;
            });
    }

    private clearForm() {
        if (!this.$store.getters.isInputChanged) return;
        if (!window.confirm('変更内容を破棄します。よろしいですか？')) return false;
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if (this.sourceShippingItemId !== null) {
            this.duplicateForm();
        } else if (this.shippingItemId && this.shippingItemId !== 'create') {
            this.getShippingItemDetail();
        } else {
            this.form = this.getEmptyForm();
        }
    }

    private async toggleVisibility() {
        if (!this.shippingItemId) return;
        if (!window.confirm(
            `出荷品目「${this.form.name}」を${ this.form.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`
        )) return;
        this.isLoading = true;
        this.$root.$emit('header-inert', true);
        try {
            const url = `${this.baseUrl}/${this.shippingItemId}/toggle-visibility`;
            const response = await this.$apiClient.doRequest('post', url, this.form);
            if (response.message) {
                window.alert(this.alertMessage + response.message);
                this.$toasted.error('変更に失敗しました。')
                return;
            }
            this.$toasted.success(this.form.isHidden ? '表示に変更しました。' : '非表示に変更しました。');
            this.previousComId = null
            this.getList();
            this.getShippingItemDetail();
            this.form.isHidden = !this.form.isHidden;
        } catch (error) {
            this.$toasted.error('保存に失敗しました。');
        } finally {
            this.$root.$emit('header-inert', false);
            this.isLoading = false;
        }
    }

    // CropFamic
    async saveCropsFamicModal(crop: CropFamic) {
        this.cropFamic = crop
        this.form.cropItemId = crop.id
        this.form.cropItemName = crop.name
        this.showCropsFamicModal = false
        const chemicals = this.form.chemicals ?? [];
        const chemIds = chemicals.map(c => `chem_ids=${c.id}`).join('&');
        const cropId = this.form.cropItemId;

        if (chemIds && cropId) {
            try {
                const res = await this.$apiClient.doRequest(
                    'get',
                    `${this.baseUrl}/chemical-active-ingredients?crop_id=${cropId}&${chemIds}`
                );
                const dataMap = Object.fromEntries(res.map((item: { id: any }) => [item.id, item]));
                this.form.chemicals = chemicals.map(chem => ({
                    ...chem,
                    usageCount: dataMap[chem.id]?.usageCount ?? [],
                    ingredients: dataMap[chem.id]?.ingredients ?? [],
                }));
            } catch {
                this.$toasted?.error('有効成分情報の取得に失敗しました。');
            }
        }
    }

    // Producers
    async commitProducers(value: { id: string; name: string; picName: string }[]) {
        this.inputChanged();
        const existing = this.form.producers ?? [];
        // this.form.deletedProducers = this.form.deletedProducers ?? [];
        // const removedProducers = existing.filter(e => !value.some(v => v.name === e.name));
        // removedProducers.forEach(p => {
        //     const alreadyDeleted = this.form.deletedProducers!.some(dp => dp.id === p.id);
        //     if (!alreadyDeleted) {
        //         this.form.deletedProducers!.push(p);
        //     }
        // });
        const updated = value.map(v => {
            const match = existing.find(e => e.id === v.id);
            return {
                id: v.id,
                name: v.name,
                picName: v.picName ?? null,
                cvPlanArea: match?.cvPlanArea ?? null,
                registrationDivision: match?.registrationDivision ?? 0,
                isDeletable: match?.isDeletable ?? true,
                updated: match?.updated ?? null,
            };
        });
        const popupProducers = this.form.comId
            ? (await this.$apiClient.doRequest('get', `/producers/committee/${this.form.comId}`)).producers
            : [];
        const preserved = existing.filter(e => !updated.some(u => u.id === e.id) && !popupProducers.some((p: { pdId: string }) => p.pdId === e.id));
        this.form.producers = [...updated, ...preserved].sort((a, b) => a.name.localeCompare(b.name));
    }

    initializeProducers(producers: ProducerModel[]) {
        return producers.map(p => ({
            id: p.id,
            name: p.name,
            picName: p.picName ?? null,
            disabledCheck: p.registrationDivision === 1 ? true : false,
        }));
    }

    deleteProducer(p: ProducerModel, index: number): void {
        if (p.isDeletable) {
            this.inputChanged();
            // this.form.deletedProducers?.push(p);
            this.form.producers?.splice(index, 1);
        } else {
            window.alert(`生産者「${p.name}」はすでにこの出荷品目を栽培履歴で使用しているため、削除できません。`);
        }
    }

    getEstimatedYield(p: ProducerModel): number {
        if (p.registrationDivision === 1) return 0;
        const { cvPlanArea } = p;
        const { averageYield } = this.form;
        if (cvPlanArea && averageYield) {
            const raw = (averageYield / 10) * cvPlanArea;
            const rounded = Math.round(raw * 100) / 100;
            return rounded;
        }
        return 0;
    }

    getTotalYield(): number {
        if (!this.form.averageYield) return 0;
        const yieldSum = (this.form.producers ?? [])
        .filter(p => p.registrationDivision !== 1 && p.cvPlanArea != null)
        .reduce((sum, p) => {
            if (this.form.averageYield == null) return sum;
            const yieldValue = (this.form.averageYield / 10) * (p.cvPlanArea ?? 0);
            return sum + yieldValue;
        }, 0);
        return Math.round(yieldSum * 100) / 100;
    }

    formatNumberWithCommas(value: number | null | undefined | ''): string {
        if (value == null || value === '') return '';
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    // Fertilizers
    commitFertilizers(value: { id: string; name: string }[]) {
        this.inputChanged();
        const existing = this.form.fertilizers ?? [];
        // this.form.deletedFertilizers = this.form.deletedFertilizers ?? [];
        // const removedFertilizers = existing.filter(e => !value.some(v => v.id === e.id));
        // removedFertilizers.forEach(f => {
        //     const alreadyDeleted = this.form.deletedFertilizers!.some(df => df.id === f.id);
        //     if (!alreadyDeleted) {
        //         this.form.deletedFertilizers!.push(f);
        //     }
        // });
        const updated = value.map(v => {
            const match = existing.find(e => e.id === v.id);
            return {
                id: v.id,
                replacementId: match?.replacementId ?? null,
                replacementName: match?.replacementName ?? null,
                name: v.name,
                approvedDate: match?.approvedDate ?? null,
                isSavedApproved: match?.isSavedApproved ?? false,
                registrationDivision: match?.registrationDivision ?? 0,
                producerName: match?.producerName ?? null,
                ownerClass: match?.ownerClass ?? 0,
                isDeletable: match?.isDeletable ?? true,
                updated: match?.updated ?? null
            };
        });
        const preserved = existing.filter(e => e.registrationDivision === 1 && !updated.find(u => u.id === e.id));
        this.form.fertilizers = [...updated, ...preserved].sort((a, b) => a.name.localeCompare(b.name));
    }

    initializeFertilizers(fertilizers: FertilizerModel[]) {
        return fertilizers.map(f => ({
            id: f.id,
            name: f.name,
            disabledCheck: f.registrationDivision === 1 ? true : false,
        }));
    }

    deleteFertilizer(f: FertilizerModel,index: number): void {
        if (f.isDeletable || confirm('既に、この肥料は、栽培履歴で使用されていますが、削除してよろしいですか？')) {
            this.inputChanged();
            // this.form.deletedFertilizers?.push(f);
            this.form.fertilizers?.splice(index, 1);
        }
    }

    async openFertilizerApprovalModal(f: FertilizerModel): Promise<void> {
        this.selectedFertilizer = f;
        if (f.ownerClass == 0) {
            f.replacementId = f.id;
            f.replacementName = f.name;
            f.approvedDate = new Date().toISOString();
            return;
        }
        const linked = await this.resolveLinkedFertilizer(f);
        if (!linked) return;
        Object.assign(f, linked);
        if (this.applyLinkedFertilizer(f, linked.linkedFertilizerId, linked.linkedFertilizerName)) return;
        this.showFertilizerApprovalModal = true;
    }

    private async resolveLinkedFertilizer(f: FertilizerModel): Promise<{ linkedFertilizerId: string | null; linkedFertilizerName: string | null } | undefined> {
        if (f.linkedFertilizerId) {
            return { linkedFertilizerId: f.linkedFertilizerId, linkedFertilizerName: f.linkedFertilizerName ?? null };
        }
        try {
            return toCamel(await this.$apiClient.doRequest('get', `/fertilizers/${f.id}/link`)) as { linkedFertilizerId: string | null; linkedFertilizerName: string | null };
        } catch {
            return undefined;
        }
    }

    closeFertilizerApprovalModal(): void {
        this.selectedFertilizer = null;
        this.showFertilizerApprovalModal = false;
    }

    approveFertilizer(fertilizer: Fertilizer | null): void {
        this.inputChanged();
        const target = this.form.fertilizers?.find(f => f.id === this.selectedFertilizer?.id);
        if (!target) return;
        if (target) {
            target.replacementId = fertilizer?.id ?? null;
            target.replacementName = fertilizer?.name ?? null;
            target.approvedDate = new Date().toISOString();
        }
    }

    private getFertilizerClass(f: FertilizerModel): string | undefined {
        if (f.ownerClass === 1 && !f.approvedDate && f.linkedFertilizerName)
          return 'color-blue';

        if (f.ownerClass === 0 && ((f.replacementId !== null && f.replacementName !== null) || (f.replacementId === undefined && f.replacementName === undefined)))
          return 'color-blue';

        if (f.ownerClass === 1 && ((f.replacementId === null && f.replacementName === null) || (f.replacementId === undefined && f.replacementName === undefined)))
          return 'color-green';

        if(f.ownerClass === 1 && (f.replacementId !== null || f.replacementName !== null))
            return 'color-blue';

        if(f.ownerClass === 0 && (f.replacementId === null || f.replacementName === null))
            return 'color-blue';
      }

    unApproveFertilizer(f: FertilizerModel): void {
        this.inputChanged();
        if (!f.isSavedApproved) {
            f.approvedDate = null;
            f.replacementId = null;
            f.replacementName = null;
        }
    }

    // Chemicals
    async commitChemicals(value: { id: number; name: string }[]) {
        this.inputChanged();
        const existing = this.form.chemicals ?? [];
        // this.form.deletedChemicals = this.form.deletedChemicals ?? [];
        // const removedChemicals = existing.filter(e => !value.some(v => v.id === e.id));
        // removedChemicals.forEach(c => {
        //     const alreadyDeleted = this.form.deletedChemicals!.some(dc => dc.id === c.id);
        //     if (!alreadyDeleted) {
        //         this.form.deletedChemicals!.push(c);
        //     }
        // });
        const chemIds = value.map(v => `chem_ids=${v.id}`).join('&');
        const cropId = this.form.cropItemId;
        let dataMap: Record<number, any> = {};

        if (chemIds && cropId) {
            try {
                const res = await this.$apiClient.doRequest('get', `${this.baseUrl}/chemical-active-ingredients?crop_id=${cropId}&${chemIds}`);
                dataMap = Object.fromEntries(res.map((item: { id: number }) => [item.id, item]));
            } catch {
                this.$toasted?.error('有効成分情報の取得に失敗しました。');
            }
        }

        const updated = value.map(v => {
            const match = existing.find(e => e.id === v.id);
            const { usageCount = [], ingredients = [], isNotSuitable, isExpired } = dataMap[v.id] ?? {};
            return {
                id: v.id,
                name: v.name,
                memo: match?.memo ?? '',
                approvedDate: match?.approvedDate ?? null,
                isSavedApproved: match?.isSavedApproved ?? false,
                registrationDivision: match?.registrationDivision ?? 0,
                producerName: match?.producerName ?? null,
                isNotSuitable,
                isExpired,
                usageCount,
                ingredients,
                isDeletable: match?.isDeletable ?? true,
                updated: match?.updated ?? null,
            };
        });
        this.form.chemicals = updated.sort((a, b) => a.id - b.id);
        this.showChemicalSelectModal = false;
    }

    initializeChemicals(chemicals: ChemicalModel[]) {
        return chemicals.map(c => ({
            id: c.id,
            name: c.name,
            disabledCheck: c.registrationDivision === 1 ? true : false,
        }));
    }

    deleteChemical(c: ChemicalModel,index: number): void {
        if (c.isDeletable || confirm('既に、この農薬は、栽培履歴で使用されていますが、削除してよろしいですか？')) {
            this.inputChanged();
            // this.form.deletedChemicals?.push(c);
            this.form.chemicals?.splice(index, 1);
        }
    }

    toggleChemicalApprove(c: ChemicalModel): void {
        this.inputChanged();
        if (!c.isSavedApproved) {
            c.approvedDate = c.approvedDate ? null : new Date().toISOString();
        }
    }

    openChemicalMemoModal(chemical: ChemicalModel) {
        if (chemical) {
            this.selectedChemical = chemical;
            this.showChemicalMemoModal = true;
        }
    }

    @Emit('inputChanged')
    private inputChanged() {
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    private handleDantai(): void {
        if (!this.selectedTenantId) return;
        const params = {
            commonUseTenantId: this.selectedTenantId,
            screenName: "SHIPPINGITEMS",
        };
        this.$apiClient.doRequest('post', '/graphScreenManagement', params).then(() => {
            this.$store.dispatch('doUpdateIsInputChanged', false);
            this.form = this.getEmptyForm();
            this.shippingItemId = null;
            this.cropFamic = null;
            this.selectedTenantId = null;
            this.selectedCollectionAndShippingGroup = null;
            this.getList();
            this.$router.push({ name: 'ShippingItems' });
        }).catch((error: any) => {
            this.$toasted.error('リクエストに失敗しました。');
        });
    }

    truncateText(text: string | null | undefined, maxLength: number): string {
        const safeText = text || '';
        if (safeText.length > maxLength) {
            return safeText.substring(0, maxLength) + '...';
        }
        return safeText;
    }

    openProducerSelectModal () {
        if (!this.form.comId) return window.alert("部会を選択してください。");
        this.showProducerSelectModal = true;
    }

    applyLinkedFertilizer(f: FertilizerModel, linkedFertilizerId?: string | null, linkedFertilizerName?: string | null): boolean {
        if (!linkedFertilizerId) return false;
        f.replacementId = linkedFertilizerId;
        f.replacementName = linkedFertilizerName ?? null;
        f.approvedDate = new Date().toISOString();
        return true;
    }

    getFertilizerDisplayName(f: FertilizerModel): string {
        if (!f.isSavedApproved && f.registrationDivision === 1 && f.approvedDate !== null && f.replacementName !== null) {
            return f.replacementName;
        }
        if (f.ownerClass === 1 && !f.approvedDate && f.linkedFertilizerName) {
            return f.linkedFertilizerName;
        }
        return f.name;
    }
}
